import { postConversationMessage, setConversationLike } from "../../../api/api";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ReactComponent as DislikeIcon } from "../../../assets/img/dislike.svg";
function Reply(props) {
  const [likeStatus, setLikeStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [sendedText, setSendedText] = useState("ارسال");
  const [loading, setLoading] = useState(false);

  function notify(t) {
    toast.success(t, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      bodyClassName: "toast-body",
      theme: "colored",
    });
  }
  function notifyError(t) {
    toast.error(t, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      bodyClassName: "toast-body",
      theme: "colored",
    });
  }
  async function send() {
    if (!message) return notifyError("پیام خالی است");
    try {
      setLoading(true);
      await postConversationMessage({ conversation_id: props.id, message });
      setSendedText("ارسال شد");
      notify("پیام شما با موفقیت ارسال شد");
    } catch (error) {
      notifyError("خطا در ارسال پیام");
    } finally {
      setLoading(false);
    }
  }
  async function like(s) {
    let status = s;
    if (props.likeStatus === s) status = 0;
    setLikeStatus(status);

    try {
      await setConversationLike(props.id, status);
      props.set(status);
    } catch (error) {
      setLikeStatus(props.likeStatus);
    } finally {
    }
  }
  useEffect(() => {
    setLikeStatus(props.likeStatus);
  }, [props.likeStatus]);
  return (
    <section className="page-section section-reply">
      <div className="container p-0 mt-5">
        <div className="message-reply">
          <div className="message-reply-header">
            <div className="d-flex">
              <div
                style={{ transform: "rotate(180deg)" }}
                className={`like-button ${likeStatus === 1 ? "liked" : ""} `}
              >
                <DislikeIcon onClick={() => like(1)} />
              </div>

              <div
                className={`like-button ${
                  likeStatus === -1 ? "disliked" : ""
                } `}
              >
                <DislikeIcon onClick={() => like(-1)} />
              </div>
            </div>
            <div>
              <button className="message-reply-button">
                <i className="bi bi-messenger"></i> سوالی دارید؟
              </button>
            </div>
          </div>

          <div className="message-textarea">
            <textarea
              onChange={(e) => setMessage(e.target.value)}
              value={message}
              placeholder="پیغام خود را بنویسید ..."
              rows={7}
            />
            <div className="d-flex flex-row-reverse">
              <button
                onClick={send}
                className="btn btn-primary"
                disabled={loading}
              >
                {loading && (
                  <span className="spinner-border spinner-border-sm ms-1" />
                )}
                {sendedText}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <ToastContainer/> */}
    </section>
  );
}

export default Reply;
